<template>
  <ContentSection class="relative mb-16 overflow-hidden last-of-type:mb-0">
    <Container indent="container-default sm:container-tight">
      <h2 class="mb-6 text-base font-semibold md:mb-10 md:px-0 md:text-lg">
        {{ data.heading }}
      </h2>
    </Container>

    <Container indent="md:container-tight">
      <!-- LOGOS  -->
      <div
        class="grid-cols-2 gap-4 xs:gap-6 md:grid md:gap-x-8 md:gap-y-12 xl:grid-cols-3 2xl:gap-x-10 2xl:gap-y-14"
      >
        <!-- DESKTOP -->
        <div
          v-for="(el, index) in cleanedPartner"
          :key="index"
          class="hidden aspect-[330/185] rounded-lg border-3 border-amber-100 bg-white md:block"
        >
          <Component
            :is="divOrNuxtLink(el)"
            v-if="el.logo"
            class="flex h-full flex-col items-center justify-center overflow-hidden px-16"
            :to="el.link"
            :aria-label="el.logo.alt"
            target="_blank"
          >
            <AppImage
              loading="lazy"
              :src="el.logo"
              :alt="el.logo.alt"
              class="max-h-[60%] rounded-lg object-contain"
            />
          </Component>
        </div>
      </div>

      <!-- MOBILE = SWIPER -->
      <Swiper
        :slides-per-view="2"
        :space-between="25"
        :prevent-clicks="false"
        :prevent-clicks-propagation="false"
        class="!mr-[-80%] overflow-hidden !pl-[8%] md:hidden"
        @swiper="onSwiper"
        @reach-beginning="
          $refs.sliderButtons.reachedBeginningOrEnd('beginning')
        "
        @reach-end="$refs.sliderButtons.reachedBeginningOrEnd('end')"
        @from-edge="$refs.sliderButtons.fromEdge()"
      >
        <SwiperSlide
          v-for="(chunk, index) in Math.ceil(cleanedPartner.length / 2)"
          :key="index"
        >
          <div
            class="style-child-images grid grid-cols-1 grid-rows-2 gap-6 sm:gap-8 sm:pr-4"
          >
            <!-- IMAGE 1 -->
            <Component
              :is="divOrNuxtLink(cleanedPartner[index * 2])"
              class="flex aspect-[330/185] flex-col items-center justify-center rounded-lg border-3 border-amber-100 bg-white px-16"
              :to="cleanedPartner[index * 2]?.link"
              :aria-label="cleanedPartner[index * 2]?.logo?.alt"
              target="_blank"
            >
              <AppImage
                loading="lazy"
                class="flex max-h-[60%] items-center overflow-hidden rounded-lg object-contain"
                :src="cleanedPartner[index * 2]?.logo"
              />
            </Component>

            <!-- IMAGE 2 -->
            <Component
              :is="divOrNuxtLink(cleanedPartner[index * 2 + 1])"
              v-if="cleanedPartner[index * 2 + 1]"
              class="flex aspect-[330/185] flex-col items-center justify-center rounded-lg border-3 border-amber-100 bg-white px-16"
              :to="cleanedPartner[index * 2 + 1]?.link"
              :aria-label="cleanedPartner[index * 2 + 1]?.logo?.alt"
              target="_blank"
            >
              <AppImage
                loading="lazy"
                class="flex max-h-[60%] items-center overflow-hidden rounded-lg object-contain"
                :src="cleanedPartner[index * 2 + 1]?.logo"
              />
            </Component>
          </div>
        </SwiperSlide>
        <SwiperSlide />
        <!-- NAV BUTTONS -->
      </Swiper>
      <div
        class="mx-auto mt-7 mb-10 mr-5 flex justify-center space-x-4 md:hidden"
      >
        <SliderButtons
          ref="sliderButtons"
          @prev="swiper.slidePrev()"
          @next="swiper.slideNext()"
        />
      </div>
    </Container>
    <!-- BACKGROUND -->
    <div
      class="absolute bottom-0 -z-10 h-[calc(100%-14.5rem)] w-full bg-amber-100"
    />
  </ContentSection>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'
import { computed } from 'vue'

// SWIPER
// Import Swiper styles
import 'swiper/css'

let swiper = {}

const onSwiper = (swiperElement) => {
  swiper = swiperElement
}

const props = defineProps({
  data: { type: Object, required: true },
})

// determine whether to load NuxtLink or button
function divOrNuxtLink(el) {
  if (el.link) {
    return resolveComponent('NuxtLink')
  }

  return 'div'
}

//cleanup array
const cleanedPartner = computed(() => {
  return props.data.partner.filter((el) => el.logo)
})
</script>
